export const NumberTwoIcon = () => {
    return (
        <svg
            width="100"
            height="130"
            viewBox="0 0 100 130"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2278_16205)">
                <path
                    d="M-13.0563 130V114.07L37.8451 65.7324C42.1174 61.7042 45.2911 58.1643 47.3662 55.1127C49.4413 52.061 50.784 49.2535 51.3944 46.6901C52.1268 44.0047 52.493 41.5024 52.493 39.1831C52.493 33.3239 50.4789 28.8075 46.4507 25.6338C42.4225 22.338 36.5024 20.6902 28.6901 20.6902C22.4648 20.6902 16.7887 21.7887 11.662 23.9859C6.65728 26.1831 2.32395 29.5399 -1.33803 34.0563L-18 21.2394C-12.9953 14.5258 -6.28169 9.33803 2.14085 5.67606C10.6854 1.89202 20.2066 0 30.7042 0C39.9812 0 48.0376 1.52582 54.8732 4.57746C61.831 7.50704 67.1409 11.7183 70.8028 17.2113C74.5869 22.7042 76.4789 29.2347 76.4789 36.8028C76.4789 40.9531 75.9296 45.1033 74.831 49.2535C73.7324 53.2817 71.6573 57.554 68.6056 62.0704C65.554 66.5869 61.0986 71.6526 55.2394 77.2676L11.4789 118.831L6.53521 109.859H81.4225V130H-13.0563Z"
                    fill="#F3F5F7"
                />
            </g>
            <defs>
                <clipPath id="clip0_2278_16205">
                    <rect width="100" height="130" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
